import { Box, Button, Card, CardBody, CardFooter, CardHeader, Flex, HStack, Heading, Spacer, Textarea, VStack, useClipboard } from "@chakra-ui/react";
import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";
import React, { useEffect } from "react";
import { ViewData } from "../data/ViewData";
import { ImageUtils } from "../utils/ImageUtils";
import { CopyIcon } from "@chakra-ui/icons";
export const AddressPage = () => {
    //const { onCopyEth, ethValue, setEthValue, hasCopiedEth } = useClipboard("");
    const copyAddress = (addr: string) => {
        //
    }
    return (
        <VStack spacing={4}>
            <NavBar />
            <Flex p={5}>
                <Card width="340px" m={5}>
                    <CardHeader>
                        <Heading size='md'>Ethereum</Heading>
                    </CardHeader>
                    <CardBody>
                        <div id="svgDivHexagram" ref={ViewData.ethAddress}/>
                    </CardBody>
                    <CardFooter>
                        {/* <Button flex='1' variant='ghost' leftIcon={<CopyIcon />} onClick={e => copyAddress(ViewData.ethAddress)}></Button> */}
                    </CardFooter>
                </Card>
                <Card width="340px" m={5}>
                    <CardHeader>
                        <Heading size='md'>Nervos</Heading>
                    </CardHeader>
                    <CardBody>
                        <Textarea value={ViewData.ckbAddress}/>
                    </CardBody>
                    <CardFooter>
                        {/* <Button flex='1' variant='ghost' leftIcon={<CopyIcon />} onClick={e => copyAddress(ViewData.ckbAddress)}></Button> */}
                    </CardFooter>
                </Card>
            </Flex>
            <Footer />
        </VStack>
    );
}